import React, { useEffect, useState } from "react";
import IconCamera from "../componentsStyled/icon/Iconcamera";
import TipoFotos from "./tipofotos";
import ImageUpload from "./imageupload";
import { Box, Button, Fab, Modal, SwipeableDrawer } from "@mui/material";
import apiConnect from "../api/apiConnect";
import LoadingBox from "./LoadingBox";
import { isMobile } from "react-device-detect";
import IconCamera2 from "../componentsStyled/icon/Iconcamera2";

interface ModalCameraProps {
  isOpen: boolean;
  pedidoID?: any;
  children?: React.ReactNode;
  onRequestClose: () => void;
  dadosSelecionados: any;
  onPhotoUploadComplete: () => void;
}

const ModalCamera: React.FC<ModalCameraProps> = ({ isOpen, pedidoID, onRequestClose, dadosSelecionados, onPhotoUploadComplete }) => {
  const [isLoading, setIsLoading] = useState(false);

  const [uploadedImages, setUploadedImages] = useState<File[]>([]);
  const [uploadedImagesUrls, setUploadedImagesUrls] = useState<any[]>([]);
  const [emptyImg, setEmptyImg] = useState(false);

  const handleImageUpload = (file: File, index: number) => {
    const updatedImages = [...uploadedImages];
    updatedImages[index] = file;
    setUploadedImages(updatedImages);
  };

  const handleUploadButtonClick = async () => {
    setIsLoading(true);
    if (uploadedImages.length > 0) {
      setEmptyImg(false);
      const auth = localStorage.getItem("auth");
      const authObj = JSON.parse(auth);
      const formData = new FormData();
      formData.append(`pedidoID`, pedidoID);
      formData.append(`produtoID`, dadosSelecionados.product_id);
      formData.append(`soldID`, dadosSelecionados.product_sold_id);
      for (let index = 0; index < uploadedImages.length; index++) {
        const file = uploadedImages[index];
        formData.append(`evidences[${index}]`, file);
      }

      const baseUrl = process.env.REACT_APP_API_URL;

      await fetch(`${baseUrl}/evidences`, {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Basic ${authObj.basicAuth}`,
        },
      })
        .then((response) =>
          response.json().then((data) => {
            setIsLoading(false);
            onPhotoUploadComplete();
            onRequestClose();
            setUploadedImagesUrls([]);
          })
        )
        .catch((error) => {
          console.error("Error uploading images:", error);
        });
    } else {
      setIsLoading(false);
      setEmptyImg(true);
    }
  };

  const handleGetImages = async () => {
    await apiConnect.apiAPP
      .get(`/evidences/${dadosSelecionados.product_sold_id}`)
      .then((resp) => {
        setUploadedImagesUrls(resp.data);
      })
      .catch((err) => {
        console.log("Error get Images:", err.response.data);
        return;
      });
  };

  useEffect(() => {
    handleGetImages();
  }, [isOpen]);

  if (isMobile) {
    return (
      <SwipeableDrawer
        anchor="bottom"
        open={isOpen}
        onClose={onRequestClose}
        onOpen={() => {}}
        swipeAreaWidth={0}
        disableSwipeToOpen={false}
        keepMounted
        sx={{
          "& .MuiDrawer-paper": {
            borderTopLeftRadius: 20,
            borderTopRightRadius: 20,
          },
        }}>
        <Box
          sx={{
            width: "20%",
            height: 5,
            backgroundColor: "#8C95A9",
            borderRadius: 10,
            margin: "5px auto",
          }}
        />
        {/* header modal */}
        <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
          <Box display={"flex"} alignItems={"center"} gap={1} ml={2}>
            <IconCamera2 width={27} className="icon-camera" />
            <p style={{ fontSize: 18, fontWeight: 500 }}>Anexar Fotos</p>
          </Box>
          <Fab
            onClick={() => {
              onRequestClose();
              setEmptyImg(false);
            }}
            sx={{ backgroundColor: "#fff", boxShadow: "none", fontSize: 20, fontWeight: 500 }}>
            X
          </Fab>
        </Box>
        {/* header modal */}

        <Box>
          <Box width={"90%"} margin={"0 auto"}>
            <p style={{ textAlign: "center" }}>Confira as dicas abaixo para garantir fotos de qualidade para a sua solicitação:</p>
          </Box>
          <br />
          <br />

          <Box>
            <TipoFotos />
            <Box display={"flex"} marginLeft={8} marginY={3}>
              <p>Anexe as fotos:</p>
            </Box>
            <Box display={"flex"} flexDirection={"row"} justifyContent={"space-evenly"} marginTop={2} marginBottom={5}>
              <ImageUpload onImageUpload={handleImageUpload} index={0} photoExist={uploadedImagesUrls[0]?.file} />
              <ImageUpload onImageUpload={handleImageUpload} index={1} photoExist={uploadedImagesUrls[1]?.file} />
              <ImageUpload onImageUpload={handleImageUpload} index={2} photoExist={uploadedImagesUrls[2]?.file} />
              <ImageUpload onImageUpload={handleImageUpload} index={3} photoExist={uploadedImagesUrls[3]?.file} />
              <ImageUpload onImageUpload={handleImageUpload} index={4} photoExist={uploadedImagesUrls[4]?.file} />
            </Box>
          </Box>
          {isLoading ? <LoadingBox loadType="static" /> : null}

          {emptyImg ? <p style={{ color: "#ff0000", marginBottom: 10 }}>Não é possível enviar os campos sem imagens.</p> : null}

          <Box mb={3}>
            <Button
              onClick={handleUploadButtonClick}
              disabled={isLoading}
              variant="contained"
              sx={{
                width: "50%",
                borderRadius: 100,
                margin: "0 auto",
                display: "block",
                backgroundColor: "#7d7d7d",
                "&:hover": {
                  backgroundColor: "#686868",
                  color: "#fff",
                },
              }}>
              Enviar fotos
            </Button>
          </Box>
        </Box>
      </SwipeableDrawer>
    );
  } else {
    return (
      <Modal
        sx={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          padding: 1,
          width: "60vw",
          height: "fit-content",
          bgcolor: "#fff",
          boxShadow: 24,
          "& .MuiBackdrop-root": { backgroundColor: "transparent" },
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          borderRadius: 10,
        }}
        open={isOpen}
        onClose={() => {
          onRequestClose();
          setEmptyImg(false);
        }}>
        <Box>
          {/* header modal */}
          <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
            <Box display={"flex"} alignItems={"center"} gap={1} ml={2}>
              <IconCamera width={27} className="icon-camera" />
              <p style={{ fontSize: 20, fontWeight: 900 }}>Anexar Fotos</p>
            </Box>
            <Fab
              onClick={() => {
                onRequestClose();
                setEmptyImg(false);
              }}
              sx={{ backgroundColor: "#fff", boxShadow: "none", fontSize: 20, fontWeight: 500 }}>
              X
            </Fab>
          </Box>
          {/* header modal */}

          <Box>
            <Box width={"50%"} margin={"0 auto"}>
              <p>Confira as dicas abaixo para garantir fotos de qualidade para a sua solicitação:</p>
            </Box>
            <br />
            <br />

            <Box>
              <TipoFotos />
              <Box display={"flex"} marginLeft={8} marginY={3}>
                <p>Anexe as fotos:</p>
              </Box>
              <Box display={"flex"} flexDirection={"row"} justifyContent={"space-evenly"} marginTop={2} marginBottom={5}>
                <ImageUpload onImageUpload={handleImageUpload} index={0} photoExist={uploadedImagesUrls[0]?.url} />
                <ImageUpload onImageUpload={handleImageUpload} index={1} photoExist={uploadedImagesUrls[1]?.url} />
                <ImageUpload onImageUpload={handleImageUpload} index={2} photoExist={uploadedImagesUrls[2]?.url} />
                <ImageUpload onImageUpload={handleImageUpload} index={3} photoExist={uploadedImagesUrls[3]?.url} />
                <ImageUpload onImageUpload={handleImageUpload} index={4} photoExist={uploadedImagesUrls[4]?.url} />
              </Box>
            </Box>

            {isLoading ? <LoadingBox loadType="static" /> : null}

            {emptyImg ? <p style={{ color: "#ff0000", marginBottom: 10 }}>Não é possível enviar os campos sem imagens.</p> : null}

            <Button
              onClick={handleUploadButtonClick}
              disabled={isLoading}
              variant="contained"
              sx={{
                width: "50%",
                borderRadius: 100,
                margin: "0 auto",
                display: "block",
                backgroundColor: "#7d7d7d",
                "&:hover": {
                  backgroundColor: "#686868",
                  color: "#fff",
                },
              }}>
              Enviar fotos
            </Button>
          </Box>
        </Box>
      </Modal>
    );
  }
};

export default ModalCamera;
